import * as React from 'react';
import { FormattedMessage } from 'react-intl';

export const steps: (keyof IMFM)[] = [
  'holdsTheHead',
  'raisesTheHead',
  'flexesTheHip',
  'dorsiflexesTheFoot',
  'raisesTheHand',
  'raisesThePelvis',
  'turnsOverIntoProne',
  'sitsUp',
  'isCapableOfMaintainingContact',
  'leansForward',
  'standsUp',
  'sitsDown',
  'maintainsSeatedPosition',
  'fromHeadInCompleteFlexionRaisesTheHead',
  'placesBothHandsOnTopOfHead',
  'reachesThePencil',
  'picksUpAndHoldsTenCoins',
  'goesRoundTheEdgeOfTheCd',
  'picksUpPencil',
  'tearsTheSheetOfPaper',
  'picksUpTheBall',
  'raisesTheFinger',
  'placesTheTwoForearms',
  'withoutUpperLimbSupportStandsUp',
  'maintainsAStandingPosition',
  'raisesTheFoot',
  'touchesTheFloor',
  'takesTenStepsForwardOnBothHeels',
  'takesTenStepsForwardOnALine',
  'runsTenMeters',
  'hopsTenTimes',
  'managesToSquatAndGetsUpTwiceInARow',
];

// TODO: Temporary solution, should be neuro-schemas based
const pickSteps = (indices: number[]) => indices.map(i => steps[i]);

export const mfmD1Steps = pickSteps([5, 7, 10, 11, 23, 24, 25, 26, 27, 28, 29, 30, 31]);
export const mfmD2Steps = pickSteps([0, 1, 2, 4, 6, 8, 9, 12, 13, 14, 15, 22]);
export const mfmD3Steps = pickSteps([3, 16, 17, 18, 19, 20, 21]);

const instructions = (stepName: string): React.JSX.Element => (
  <div style={{ fontStyle: 'italic' }}>
    <FormattedMessage id={'motor.labels.mfm.' + stepName + 'Instruction'} />
  </div>
);

export const getStepContent = (
  stepName: string,
): {
  opts: (number | string)[];
  optsLocale: string;
  info?: string;
  height?: number;
  instruction?: React.JSX.Element;
  instruction2?: React.JSX.Element;
  instruction3?: React.JSX.Element;
} => ({
  opts: [0, 1, 2, 3],
  optsLocale: 'opts',
  instruction: instructions(stepName),
});
